/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ContratAvenantSearchDto
 */
export interface ContratAvenantSearchDto {
    /**
     * 
     * @type {number}
     * @memberof ContratAvenantSearchDto
     */
    idcontrat?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContratAvenantSearchDto
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContratAvenantSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ContratAvenantSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ContratAvenantSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContratAvenantSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ContratAvenantSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ContratAvenantSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ContratAvenantSearchDto interface.
 */
export function instanceOfContratAvenantSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratAvenantSearchDtoFromJSON(json: any): ContratAvenantSearchDto {
    return ContratAvenantSearchDtoFromJSONTyped(json, false);
}

export function ContratAvenantSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratAvenantSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcontrat': !exists(json, 'idcontrat') ? undefined : json['idcontrat'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ContratAvenantSearchDtoToJSON(value?: ContratAvenantSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcontrat': value.idcontrat,
        'showDeleted': value.showDeleted,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

